<script>
import { Podcast, PodcastCategory, PodcastsListingPage } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'
import moment from 'moment/moment'
import { cloneDeep } from 'lodash'

export default {
  mixins: [FormMixin],
  data() {
    return {
      redirectRoute: { name: 'Podcasts List Page' }
    }
  },
  created() {},
  methods: {
    onSubmit() {
      this.loading = true
      this.errors = {}
      const payload = this.getSavePayload()
      const service = this.service.update(payload.id, payload)
      service
        .then(response => {
          this.successRedirect = true
          this.successHandler(response)
        })
        .catch(this.errorHandler)
    },
    fetchData() {
      this.loading = true
      this.service
        .get()
        .then(response => {
          this.form = response.data
          this.instanceFetchCallback()
          this.formCopy = cloneDeep(this.form)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getSidebarFields() {
      return [
        new fields.Header({
          type: 'h4',
          text: 'Data utworzenia'
        }),
        new fields.Date({
          type: 'datetime',
          modelPath: [this, 'form', 'created'],
          disabled: true
        }),
        new fields.Header({
          type: 'h4',
          text: 'Data modyfikacji'
        }),
        new fields.Date({
          type: 'datetime',
          modelPath: [this, 'form', 'modified'],
          disabled: true
        })
      ]
    },
    getFields() {
      return [
        {
          component: 'el-tabs',
          children: [this.getGeneralTab(), this.getSEOTab()]
        }
      ]
    },
    getGeneralTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'Ogólne'
        },
        children: [
          new fields.Input({
            label: 'Tytuł strony',
            modelPath: [this, 'form', 'title'],
            multilingual: true,
            required: true
          }),
          new fields.Input({
            label: 'Tytuł',
            modelPath: [this, 'form', 'subtitle'],
            multilingual: true,
            required: true
          }),
          new fields.Input({
            label: 'Nagłówek',
            modelPath: [this, 'form', 'heading'],
            multilingual: true,
            required: true
          }),
          new fields.Input({
            label: 'Opis',
            modelPath: [this, 'form', 'description'],
            required: true,
            multilingual: true
          })
        ]
      }
    },
    getSEOTab() {
      return {
        component: 'el-tab-pane',
        attrs: {
          label: 'SEO'
        },
        children: [
          new fields.Input({
            label: 'Slug',
            modelPath: [this, 'form', 'slug'],
            multilingual: true,
            condition: !!this.form.id,
            disabled: true
          }),
          new fields.Input({
            label: 'Tytuł dla facebooka',
            modelPath: [this, 'form', 'og_title'],
            multilingual: true
          }),
          new fields.Input({
            label: 'Opis dla facebooka',
            modelPath: [this, 'form', 'og_description'],
            type: 'textarea',
            multilingual: true
          }),
          new fields.Image({
            label: 'Zdjęcie dla facebooka',
            modelPath: [this, 'form', 'og_image']
          }),
          new fields.Input({
            label: 'Tytuł strony dla wyszukiwarki google',
            modelPath: [this, 'form', 'meta_title'],
            multilingual: true
          }),
          new fields.Input({
            label: 'Opis dla wyszukiwarki google',
            modelPath: [this, 'form', 'meta_description'],
            type: 'textarea',
            multilingual: true
          })
        ]
      }
    }
  },
  computed: {
    service() {
      return PodcastsListingPage
    }
  }
}
</script>
